import type { VerifyCompanyNccParams } from '../types';
import { companyApi } from '../companyApi';
import { MutationKey } from '@shared/config';
import { useMutation } from '@tanstack/react-query';

export const useVerifyCompanyNcc = () => {
  return useMutation({
    mutationKey: [MutationKey.VERIFY_COMPANY_NCC],
    mutationFn: (params: VerifyCompanyNccParams) =>
      companyApi.verifyCompanyNcc(params),
  });
};
